<div class="modal" [class.modal--open]="isVisible" [ngClass]="cssClass">
  <div class="modal-background" (click)="clickOutside()"></div>
  <div
    *ngIf="isVisible"
    [@slideInOut]="'slideFromBottom'"
    (@slideInOut.done)="onAnimationEvent($event)"
    [id]="modalId"
    class="modal-dialog"
    [attr.role]="role"
    [attr.aria-labelledby]="modalTitleId"
    [attr.aria-describedby]="modalDescId"
    [attr.aria-modal]="true"
  >
    <span tabindex="0" (focus)="focusLastFocusable()"></span>

    <div class="modal-content outline-none">
      <div class="modal__header">
        <button
          *ngIf="hasCloseButton"
          app-vtmn-play-icon-button
          type="button"
          class="modal__header__close-button"
          [type]="ctaButtonType.Button"
          [variant]="vtmnPlayIconButtonVariant.TERTIARY"
          [attr.aria-label]="
            'a11y.design_system.modal.close_button' | translate
          "
          (click)="closeModal()"
        >
          <vtmn-play-icon [name]="iconType?.Close"></vtmn-play-icon>
        </button>

        <h2 class="modal__header__title" [id]="modalTitleId">
          <ng-content select="[modal-header]"></ng-content>
        </h2>
      </div>

      <div [id]="modalDescId" class="modal__content">
        <ng-content select="[modal-content]"></ng-content>
      </div>

      <div class="modal__footer">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>

    <span tabindex="0" (focus)="focusFirstFocusable()"></span>
  </div>
</div>
